import type { SchemaOf } from '../helpers';
import { Joi, objectSchemaOf } from '../helpers';

export interface IInvitation {
  id: string;
  hasCheckedIn: boolean;
  checkInTime?: number;

  organisationId: string;
  staffId: string;
  isValidated: boolean;

  startsAt: number;
  endsAt: number;
  attendeeNames: string[];
}

export const invitationSchemaMap: SchemaOf<IInvitation> = {
  id: Joi.string().required(),
  hasCheckedIn: Joi.boolean().required(),
  checkInTime: Joi.number().optional(),
  organisationId: Joi.string().required(),
  staffId: Joi.string().required(),
  isValidated: Joi.boolean().required(),
  startsAt: Joi.number().required(),
  endsAt: Joi.number().required(),
  attendeeNames: Joi.array().items(Joi.string()).required(),
};

export const invitationSchema = objectSchemaOf<IInvitation>(
  invitationSchemaMap
);
